import {
	Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
	Enum_Componentinternaldefaultmoduleoptions_Padding,
	GetLocalSitemapRegioExpresQuery
} from 'api/graphql-types';
import { GetServerSideProps } from 'next';
import client from 'api/apollo-client';
import { getServerPageGetLocalSitemapRegioExpres } from 'api/graphql-helper';
import { Head } from 'modules/head/head';
import Layout from 'modules/layout/layout';
import { BaseModule } from 'modules/base-module/base-module';
import IntroHeader from 'modules/intro-header/intro-header';
import { Sitemap } from 'modules/sitemap';
import { ROUTES } from 'constants/routes';
import { ISitemapPage } from 'modules/sitemap/generate-sitemap/page-data-to-sitemap-xml';
import { generateSitemap } from 'modules/sitemap/generate-sitemap/generate-sitemap';
import { initialState as settingsInitialState } from 'redux/stores/settings';

const SitemapPage = ({
	regioExpresInformation,
	sitemap,
	...rest
}: GetLocalSitemapRegioExpresQuery): React.JSX.Element => {
	const headerDefaultOptions = {
		backgroundColor: sitemap?.data?.attributes?.header
			?.backgroundColor as Enum_Componentinternaldefaultmoduleoptions_Backgroundcolor,
		padding: 'none' as Enum_Componentinternaldefaultmoduleoptions_Padding
	};

	return (
		<Layout
			navbar={regioExpresInformation?.data?.attributes?.navbar}
			footer={regioExpresInformation?.data?.attributes?.footer}
		>
			<Head seoModule={sitemap?.data?.attributes?.seo} seoParent={regioExpresInformation?.data?.attributes?.seo} />
			<BaseModule defaultModuleOptions={headerDefaultOptions}>
				<IntroHeader module={sitemap?.data?.attributes?.header} slug={ROUTES.SITEMAP.fullPath} />
			</BaseModule>
			<BaseModule>
				<Sitemap data={rest as unknown as Record<string, ISitemapPage[]>} />
			</BaseModule>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
	try {
		const { locale } = ctx;

		const pageResult = await getServerPageGetLocalSitemapRegioExpres(
			{
				variables: {
					locale
				}
			},
			client
		);

		const sitemap = await generateSitemap({ context: ctx, domain: 'regio-expres' });

		return {
			// Merge static and dynamic pages in single object
			props: {
				initialReduxState: {
					settings: {
						...settingsInitialState,
						showNeutralStyle: true,
						hideLanguageSwitcher: true,
						hideSearchbar: true,
						isSubsite: true
					}
				},
				...pageResult.props.data,
				...sitemap
			}
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in sitemap', error);

		return {
			notFound: true
		};
	}
};

export default SitemapPage;
